import EditPublicationContainer from "../containers/EditPublicationContainer";

const EditPublicationPage = () => {
  return (
    <EditPublicationContainer />
  );
};

export default EditPublicationPage;
